import React from 'react'

export function VimeoIcon(props) {


    return (
        <><svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.9879 4.85527C23.8835 7.22196 22.2494 10.4572 19.0969 14.5624C15.8344 18.8551 13.07 21 10.8107 21C9.4137 21 8.22975 19.695 7.26312 17.0765C6.61541 14.674 5.97193 12.2716 5.32563 9.87626C4.60595 7.2563 3.83547 5.94703 3.01137 5.94703C2.83215 5.94703 2.20702 6.32908 1.12891 7.09461L0 5.61936C1.18253 4.56766 2.34813 3.51166 3.49821 2.45852C5.07304 1.07628 6.25698 0.350823 7.04722 0.274986C8.90992 0.0918324 10.0586 1.38393 10.4918 4.14698C10.9532 7.13038 11.2778 8.98482 11.457 9.71171C11.9961 12.1843 12.5859 13.4177 13.2322 13.4177C13.7332 13.4177 14.4867 12.6193 15.4915 11.021C16.4962 9.41981 17.031 8.20355 17.1044 7.36505C17.2483 5.98281 16.7107 5.29598 15.4915 5.29598C14.9171 5.29598 14.3245 5.41904 13.7163 5.6766C14.9016 1.78601 17.1594 -0.105631 20.4954 0.00454819C22.9663 0.0746616 24.1333 1.69443 23.9879 4.85527Z" fill="#0A142F" />
        </svg>

        </>
    )
}
